import { DatePipe } from '@angular/common';
import { Injectable } from '@angular/core';
import { of, Subject } from 'rxjs';
import { EventDetailsModelResponse, EventModel, EventModelRequest, UpdateEventModelRequest } from '../_models/Event/EventModel';

@Injectable({
  providedIn: 'root'
})
export class EventService {
  eventsChanged = new Subject<EventModel[]>();
  private events: EventModel[] = [];
  pageNumber: number;
  totalPages: number;
  totalRecords: number;

  private eventDetails: EventDetailsModelResponse;

  constructor() { }

  getEvents() {
    return this.events.slice();
  }
  getEventsPageNumber() {
    return this.pageNumber;
  }
  getEventsTotalPages() {
    return this.totalPages;
  }

  getTotalRecords() {
    return this.totalRecords;
  }

  //not using at the moment
  getEvent(index: number) {
    return this.events[index];
  }

  //not using at the moment
  addEvent(event: EventModel) {
    this.events.push(event)
    this.eventsChanged.next(this.events.slice());
  }
  //for Update not using at the moment
  setEvents(events: EventModel[], pageNumber: number, totalPages: number, totalRecords: number) {
    this.pageNumber = pageNumber;
    this.totalPages = totalPages;
    this.totalRecords = totalRecords;

    events.forEach((element: EventModel) => {
      this.formateDate(element);
    });

    if (pageNumber > 1) {
      this.events = this.events.concat(events);
    } else {
      this.events = events;
    }

    this.eventsChanged.next(this.events.slice());
  }

  //not using at the moment
  deleteEvent(index: number) {
    this.events.splice(index, 1);
    this.eventsChanged.next(this.events.slice());
  }

  updateEventReservationsInfo(updatedEvent: EventModel) {  
    let item = this.events.find(event => event.id === updatedEvent.id);
    if (item) {
      item.available = updatedEvent.available;
      item.confirmed = updatedEvent.confirmed;
      item.expected = updatedEvent.expected;
      item.pending = updatedEvent.pending;
      item.seated = updatedEvent.seated;
      item.lateGuest = updatedEvent.lateGuest;
      this.eventsChanged.next(this.events.slice());
    }
  }

  setEventValues(event: EventModelRequest) {
    const formData = new FormData();
    formData.append('Name', event.Name as string)
    formData.append('Description', event.Description as string)
    formData.append('Title', event.Title as string)
    formData.append('StartDateTime', event.StartDateTime as string)
    formData.append('StartTime', event.StartTime as string)
    formData.append('EndDateTime', event.EndDateTime as string)
    formData.append('VenueId', event.VenueId as string)
    formData.append('MaximumCapacity', String(event.MaxCapacity))
    formData.append('PictureUrl', event.PictureUrl as string)
    if(event.EventTypesIds != undefined){
      for(let i = 0; i < event.EventTypesIds.length; i++) {
        formData.append("EventTypesIds", event.EventTypesIds[i])
      }
    }
    return formData;
  }

  setUpdateValues(event: UpdateEventModelRequest){
    const formData = new FormData();
    formData.append('Id',event.Id as string)
    formData.append('Name', event.Name as string)
    formData.append('Description', event.Description as string)
    formData.append('Title', event.Title as string)
    formData.append('StartDateTime', event.StartDateTime as string)
    formData.append('StartTime', event.StartTime as string)
    formData.append('EndDateTime', event.EndDateTime as string)
    formData.append('VenueId', event.VenueId as string)
    formData.append('MaximumCapacity', String(event.MaxCapacity))
    if(typeof event.PictureUrl === 'string') {
      //@ts-ignore
      formData.append('PictureUrl', '')
    } else {
      //@ts-ignore
      formData.append('PictureUrl', event.PictureUrl as string)
    }
    if(event.EventTypesIds != undefined){
      for(let i = 0; i < event.EventTypesIds.length; i++) {
        formData.append("EventTypesIds", event.EventTypesIds[i])
      }
    }
    return formData;
  }

  setEventDetailsValues(event: EventDetailsModelResponse){
    this.eventDetails = event;
  }
  getEventDetailsValues() {
    return this.eventDetails;
  }
  formateDate(event: EventModel){
    const datepipe: DatePipe = new DatePipe('en-US');
    //z for local timezone
    let date = new Date((event.startDateTime as string)+"Z");
    let formattedDate = datepipe.transform(date, 'EE, d MMM, y');
    let formatedTime = datepipe.transform(date, 'hh:mm a');
      if(formattedDate && formatedTime !== null) {
        event.startDateTime = formattedDate;
        event.startTime = formatedTime;
      }
  }
}
